import React from 'react'
import { FormContextProvider } from '../../../context/formContext'
import ElegibilidadForm from './Elegibilidad'
import Toast from '../../../components/Toast/Toast'
import { ElegibilidadProvider } from '../../../context/ElegibilidadContext'
import { EligibilityContextProvider } from '../../../context/EligibilityContext'
const FormElegibilidad = () => {
  return (
    <EligibilityContextProvider>
      <FormContextProvider>
        <ElegibilidadProvider>
          <ElegibilidadForm />
          <Toast />
        </ElegibilidadProvider>
      </FormContextProvider>
    </EligibilityContextProvider>
  )
}

export default FormElegibilidad
